import * as React from "react"
import * as _ from "lodash"
import IMealSlot from "../models/IMealSlot"
import IFoodCategory from "../models/IFoodCategory"
import FoodGroupEditViewCont from "./EditView/FoodGroupsEditViewCont"
import {EditViewDisplayMode} from "../components/common/EditViewCard"
import IFetchMealsByCaloriesRequest from "../models/IFetchMealsByCaloriesRequest"
import IMealItem from "../models/IMealItem"
import ModelFactory from "../models/ModelFactory"
import MealsContainer from "./MealsContainer"
import {LOADING_STATE} from "../utils/AppUtils"
import AppLoader from "../components/utils/AppLoader"
import MealItemEditor from "../components/patient/edit/MealItemEditor";
import CustomMealBuilderContainer from "./CustomMealBuilderContainer";
import IDishCatalogueResponse from "../models/maverick/IDishCatalogueResponse";
import IFoodGroup from "../models/IFoodGroup";
import TimePicker from "../components/TimePicker"
import {IDietMeal} from "../models/LCPlanClientModels";

/*
 * created by aditya on 18/7/2018
 */

export interface MealBuilderContainerProps {
    mealSlot: IDietMeal,
    staticFoodGroups: IFoodCategory[],
    updateMealSlots: (updatedMealSlots: IDietMeal) => void,
    fetchMealByCalories: (calorieBreakup: IFetchMealsByCaloriesRequest) => Promise<IMealItem[]>;
    fetchDishByDishName: (input: string) => Promise<IDishCatalogueResponse[]>;
    fetchMealByMealId: (mealId: string) => Promise<IMealItem>;
    previewMeal: (meal: IMealItem) => Promise<IMealItem>;
    createMeal: (meal: IMealItem) => Promise<IMealItem>;
    suggestions: {[key: string]: any}
}

export interface MealBuilderContainerState {
    meals: IMealItem[],
    fetchMealsState: LOADING_STATE
}

class MealBuilderContainer extends React.Component<MealBuilderContainerProps, MealBuilderContainerState> {
    private foodGroupEditViewContRef: any;
    constructor(props: MealBuilderContainerProps) {
        super(props);
        this.state = {
            meals: [],
            fetchMealsState: LOADING_STATE.NOT_INITIALIZED
        }
    }
    componentWillReceiveProps(nextProps: MealBuilderContainerProps) {
        if (nextProps.mealSlot.mealSlot !== this.props.mealSlot.mealSlot) {
            this.setState({
                meals: [],
                fetchMealsState: LOADING_STATE.NOT_INITIALIZED
            })
        }
    }
    getSaveObject = () => {
        let calorieBreakup = this.foodGroupEditViewContRef.getSaveObject();
        let mealSlot = { ...this.props.mealSlot };
        mealSlot.details.calorieBreakup = calorieBreakup;
        return mealSlot;
    }
    planMeals = () => {
        let breakup = this.foodGroupEditViewContRef.getSaveObject();
        let updatedMealSlot = { ...this.props.mealSlot }
        updatedMealSlot.details.calorieBreakup = breakup;
        this.props.updateMealSlots(updatedMealSlot);
        if (breakup.length) {
            let request = ModelFactory.createNewFetchMealsByCaloriesRequest();
            request.foodGroupBreakup = breakup[0];       // TODO: Multiple items of calorieBreakup to be passed
            request.mealSlot = this.props.mealSlot.mealSlot;
            let minRange = parseInt(this.props.mealSlot.details.calories.toString()) - 100;
            let maxRange = parseInt(this.props.mealSlot.details.calories.toString()) + 100;
            request.calorieRange = {
                min: minRange,
                max: maxRange
            };
            let myInstance = this;
            this.setState({ fetchMealsState: LOADING_STATE.LOADING }, () => {
                myInstance.props.fetchMealByCalories(request).then((meals: IMealItem[]) => {
                    myInstance.setState({
                        meals,
                        fetchMealsState: LOADING_STATE.LOADED
                    })
                });
            })
        }
    }
    onMealSelect = (mealItem: IMealItem) => {
        let mealSlot = { ...this.props.mealSlot };
        let currentMealIds = !_.isEmpty(this.props.mealSlot.details.mealIds) ? this.props.mealSlot.details.mealIds : [];
        if (currentMealIds.indexOf(mealItem.mealId) === -1) {
            currentMealIds.push(mealItem.mealId);
            mealSlot.details.mealIds = currentMealIds;

            let meals: IMealItem[] = !_.isEmpty(this.props.mealSlot.details.meals) ? this.props.mealSlot.details.meals : [];
            if (meals.map(item => item.mealId).indexOf(mealItem.mealId) === -1) {
                meals.push(mealItem);
                mealSlot.details.meals = meals;
            }

            this.props.updateMealSlots(mealSlot);
        }
    }
    onMealRemove = (mealId: string) => {
        let mealSlot = { ...this.props.mealSlot };
        let currentMealIds = !_.isEmpty(this.props.mealSlot.details.mealIds) ? this.props.mealSlot.details.mealIds : [];
        let index = currentMealIds.indexOf(mealId);
        if (index !== -1) {
            currentMealIds.splice(index, 1);
            mealSlot.details.mealIds = currentMealIds;

            let meals: IMealItem[] = !_.isEmpty(this.props.mealSlot.details.meals) ? this.props.mealSlot.details.meals : [];
            index = meals.map(item => item.mealId).indexOf(mealId);
            if (index !== -1) {
                meals.splice(index, 1);
                mealSlot.details.meals = meals;
            }

            this.props.updateMealSlots(mealSlot);
        }
    }
    updateMealSlots = (calorieBreakup: IFoodGroup[]) => {
        let updatedMealSlot = { ...this.props.mealSlot }
        updatedMealSlot.details.calorieBreakup = calorieBreakup;
        this.props.updateMealSlots(updatedMealSlot);
    }

    updateMealBuilderTime = (time: string) => {
        let mealSlot = { ...this.props.mealSlot };
        mealSlot.recommendedTimeOfDay = time;
        this.props.updateMealSlots(mealSlot);
    }

    render() {
        let foodGroupDistribution = this.props.mealSlot.details.calorieBreakup;
        let mealTime = _.isEmpty(this.props.mealSlot.recommendedTimeOfDay) ? "" : this.props.mealSlot.recommendedTimeOfDay;
        return (
            <div className={"meal-builder-sub-container"}>
                <div className={"meal-builder-time-value"}>
                    <span className={"meal-builder-time-label"}>Meal Time:</span>
                    <TimePicker supportMeridiem={false} value={mealTime} onTimeChange={(time: string) => this.updateMealBuilderTime(time)} />
                </div>
                <div className={"meal-builder-food-categories-container"}>
                    <FoodGroupEditViewCont ref={(dom) => this.foodGroupEditViewContRef = dom} foodGroupDistribution={foodGroupDistribution}
                                           staticFoodGroups={this.props.staticFoodGroups}
                                           displayMode={EditViewDisplayMode.EDIT} updateMealSlots={this.updateMealSlots}/>
                    {/*<div className={"button-container"}>
                        <input type="button" value="Plan Meals" onClick={this.planMeals} />
                    </div>*/}
                </div>
                {
                    !_.isEmpty(this.props.mealSlot.details.mealIds) &&
                    <div className={"selectedMeals"}>
                        {
                            _.map(this.props.mealSlot.details.mealIds, (meal, index) => {
                                return <div className={"complete-meal-item"} key={meal}>
                                    <MealItemEditor
                                        mealId={meal}
                                        onMealRemove={this.onMealRemove}
                                        fetchMealByMealId={this.props.fetchMealByMealId}
                                        mealSlot={this.props.mealSlot.mealSlot}
                                        addMeal={this.onMealSelect}
                                        fetchStaticDishes={this.props.fetchDishByDishName}
                                        createMeal={this.props.createMeal}
                                        suggestions={this.props.suggestions}
                                    />
                                </div>
                            })
                        }
                    </div>
                }
                <CustomMealBuilderContainer mealSlot={this.props.mealSlot.mealSlot} addMeal={this.onMealSelect} 
                fetchStaticDishes={this.props.fetchDishByDishName} previewMeal={this.props.previewMeal} 
                createMeal={this.props.createMeal} suggestions={this.props.suggestions}/>
                {
                    this.state.fetchMealsState === LOADING_STATE.LOADING &&
                    <AppLoader/>
                }
                {
                    this.state.fetchMealsState === LOADING_STATE.LOADED &&
                    <MealsContainer meals={this.state.meals}
                                    onMealSelect={this.onMealSelect} onMealRemove={this.onMealRemove}
                                    selectedMeals={this.props.mealSlot.details.meals} />
                }
            </div>
        )
    }
}

export default MealBuilderContainer;